class UgcBeforeAfterCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.prevButton = this.querySelector('[data-prev]');
    this.nextButton = this.querySelector('[data-next]');

    if (!this.track || !this.prevButton || !this.nextButton) return;

    this.scrollFrame = null;

    this.handlePrevClick = this.handlePrevClick.bind(this);
    this.handleNextClick = this.handleNextClick.bind(this);
    this.handleScroll = this.handleScroll.bind(this);

    this.prevButton.addEventListener('click', this.handlePrevClick);
    this.nextButton.addEventListener('click', this.handleNextClick);
    this.track.addEventListener('scroll', this.handleScroll, { passive: true });

    this.updateArrowState();
  }

  disconnectedCallback() {
    this.prevButton?.removeEventListener('click', this.handlePrevClick);
    this.nextButton?.removeEventListener('click', this.handleNextClick);
    this.track?.removeEventListener('scroll', this.handleScroll);
  }

  get slideStep() {
    const slide = this.track.querySelector('[data-slide]');
    if (!slide) return 0;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    return slide.getBoundingClientRect().width + gap;
  }

  handlePrevClick() {
    this.scrollByAmount(-this.slideStep);
  }

  handleNextClick() {
    this.scrollByAmount(this.slideStep);
  }

  scrollByAmount(amount) {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.track.scrollBy({ left: amount, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
  }

  handleScroll() {
    if (this.scrollFrame) return;
    this.scrollFrame = requestAnimationFrame(() => {
      this.updateArrowState();
      this.scrollFrame = null;
    });
  }

  updateArrowState() {
    const maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;
    this.prevButton.disabled = this.track.scrollLeft <= 0;
    this.nextButton.disabled = this.track.scrollLeft >= maxScroll;
  }
}

if (!customElements.get('ugc-before-after-carousel')) {
  customElements.define('ugc-before-after-carousel', UgcBeforeAfterCarousel);
}
